import React, { useEffect, useState } from 'react';
import { Typography, Alert, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import api from '../api';
import HelpdeskInvolvedTickets from '../components/HelpdeskInvolvedTickets';
import HelpdeskCreateModal from '../components/HelpdeskCreateModal';

// My Hub > My HelpDesk: the tickets the current user is on as the Impacted
// Employee or a watcher. New Ticket is the Help Desk page's own popup, so the
// same rules decide who a ticket can be raised for (the server's employee
// list, Can Create and Restricted Impacted Employees, checked again on create).
export default function MyHelpdeskPage() {
  const [createOpen, setCreateOpen] = useState(false);
  const [filterOpts, setFilterOpts] = useState({ teams: [], users: [] });

  useEffect(() => {
    api.get('/api/helpdesk/filter-options').then((r) => setFilterOpts(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>My HelpDesk</Typography.Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateOpen(true)}>New Ticket</Button>
      </div>
      <Alert type="info" showIcon style={{ marginBottom: 12 }}
        message="View all tickets you raised, are the impacted employee on, or watch." />
      <HelpdeskInvolvedTickets />
      <HelpdeskCreateModal open={createOpen} onClose={() => setCreateOpen(false)} filterOpts={filterOpts} />
    </div>
  );
}
